import React, { useState, useEffect } from 'react'
import { useSelector } from 'react-redux'
import axios from 'axios'
import { Container, Breadcrumb, BreadcrumbSection, BreadcrumbDivider, Form, FormGroup, FormField, Input, TextArea, Button, Icon, Checkbox, Divider, Header } from 'semantic-ui-react'

const CreateReseller = ({ goBack }) => {
    const [name, setName] = useState('')
    const [phone, setPhone] = useState('')
    const [email, setEmail] = useState('')
    const [password, setPassword] = useState('')
    const [balance, setBalance] = useState(0)
    const [markup, setMarkup] = useState({})
    const [remarks, setRemarks] = useState('')
    const [disableDiscounts, setDisableDiscounts] = useState(false)
    const [launchedGames, setLaunchedGames] = useState([])

    const user = useSelector(state => state.userAdmin)

     useEffect(() => { // determine the mark up fields in renderMarkupFields() with launchedGames data
            axios.get('/api/launched_games').then((res) => setLaunchedGames(res.data))
        }, [])
    
    const handleChangeField = e => {
        const { name, value } = e.target
        if (name === 'name') setName(value)
        if (name === 'phone') setPhone(value)
        if (name === 'email') setEmail(value)
        if (name === 'password') setPassword(value)
        if (name === 'balance') setBalance(value)
        if (name.includes('markup')) {
            const key = name.split('-')[1]
            const newMarkup = {...markup}
            newMarkup[key] = value
            setMarkup(newMarkup)
        }
        if (name === 'remarks') setRemarks(value)
    }
    const handleToggle = (e, data) => {
        setDisableDiscounts(data.checked)
    }
    const handleSaveClicked = async () => {
        const convertedMarkup = Object.fromEntries(Object.entries(markup).map(([key, value]) => [key, Number(value)]))
        const dict = { createdBy: user.name, createdAt: Date(), name, phone, email, password, balance: Number(balance), markup: convertedMarkup, remarks, disableDiscounts, 
                        rank: 'Reseller', balanceHistory: [{ date: new Date().toString(), old: 0, new: Number(balance), type: 'initial', order: {} }]
        }
        await axios.post('/api/reseller', dict)
            .then(() => {
                goBack()
            })
            .catch(err => {
                console.log(`create reseller failed with error: ${err}`)
                alert(`Failure creating reseller, please try again. Error: ${err}`)
            })
    }

    const handleCancelClicked = () => {
        goBack()
    }

    const renderDetailsFields = () => {
        return (
            <Container>
                <Form inverted>
                    <FormGroup widths="equal">
                        <FormField control={Input} label="Name" name="name" value={name} placeholder="Name" onChange={handleChangeField} inverted className="dark-theme-input"/>
                        <FormField control={Input} label="Phone" name="phone" value={phone} placeholder="Phone" onChange={handleChangeField} inverted className="dark-theme-input"/>
                    </FormGroup>
                    <FormGroup widths="equal">
                        <FormField control={Input} label="Email" name="email" value={email} placeholder="" onChange={handleChangeField} inverted className="dark-theme-input"/>
                        <FormField control={Input} label="Password" type="password" name="password" value={password} placeholder="" onChange={handleChangeField} inverted className="dark-theme-input"/>
                    </FormGroup>
                    <FormField control={Input} label="Balance" name="balance" value={balance} placeholder="" onChange={handleChangeField} inverted className="dark-theme-input"/>
                    <FormField control={TextArea} rows="2" label="Remarks" name="remarks" value={remarks} placeholder="" onChange={handleChangeField} inverted className="dark-theme-textarea-field"/>
                    <FormField control={Checkbox} label="Disable Discounts" name="disableDiscounts" checked={disableDiscounts} onChange={handleToggle} inverted/>
                </Form>
            </Container>
        )
    }
    const renderPriceMarkUpFields = () => {
        const fields = []
        fields.push( // mlbb fields are fixed
        <FormGroup key={'lol'} widths="equal">
            <FormField required control={Input} label="mlbb" name="markup-mlbb" value={markup.mlbb} onChange={handleChangeField} inverted className="dark-theme-input"/>
            <FormField required control={Input} label="mlbb_global" name="markup-mlbb_global" value={markup.mlbb_global} onChange={handleChangeField} inverted className="dark-theme-input"/>
            <FormField required control={Input} label="mlbb_special" name="markup-mlbb_special" value={markup.mlbb_special} onChange={handleChangeField} inverted className="dark-theme-input"/>
        </FormGroup>)

        const gameFields = [] // other games' fields are dynamic
        for (const game of launchedGames) {
            if (game.supplierName === 'mlbb') continue
            const fieldName = 'markup-' + game.supplierName
            gameFields.push(<FormField key={game.supplierName} control={Input} label={game.name} name={fieldName} value={markup[game.supplierName]} onChange={handleChangeField} inverted className="dark-theme-input"/>)
        }
        for (let i = 0; i < gameFields.length; i += 3) { // 3 fields per group
            fields.push(<FormGroup widths="equal" key={`game-group-${i}`}>{gameFields.slice(i, i + 3)}</FormGroup>)
        }
        return <Form inverted>{fields}</Form>
    }

    return (
        <Container inverted style={{ background: '#1b1c1d', marginTop: 35 }}>
            <Breadcrumb inverted style={{ marginBottom: 30 }} size="large">
                <BreadcrumbSection onClick={handleCancelClicked} style={{ color: 'white', cursor: 'pointer' }}>Resellers</BreadcrumbSection>
                <BreadcrumbDivider color='teal' icon="right chevron"/>
                <BreadcrumbSection active style={{ color: 'white' }}>Create New Reseller</BreadcrumbSection>
            </Breadcrumb>
            <Divider inverted style={{ marginTop: 5, marginBottom: 20 }} horizontal><Header inverted as="h4"><Icon inverted name="info" />Details</Header></Divider>
            {renderDetailsFields()}
            <Divider inverted style={{ marginTop: 55, marginBottom: 20 }} horizontal><Header inverted as="h4"><Icon inverted name="dollar" />Price Markup %</Header></Divider>
            {renderPriceMarkUpFields()}
            <Button inverted style={{ marginTop: 40, marginRight: 15 }} color='teal' onClick={handleSaveClicked}><Icon color='teal' inverted name="check" />Create Reseller</Button>
            <Button inverted onClick={handleCancelClicked}>
                <Icon inverted name="reply" />Back
            </Button>
        </Container>
    )
}

export default CreateReseller